import { render, staticRenderFns } from "./historyDate.vue?vue&type=template&id=5324e547&scoped=true&"
import script from "./historyDate.vue?vue&type=script&lang=js&"
export * from "./historyDate.vue?vue&type=script&lang=js&"
import style0 from "./historyDate.vue?vue&type=style&index=0&id=5324e547&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324e547",
  null
  
)

export default component.exports